var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"instagram"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("g",{"id":"instagram"},React.createElement("path",{"d":"M29.5,22A7.5,7.5,0,1,0,37,29.5,7.51,7.51,0,0,0,29.5,22Zm0,0A7.5,7.5,0,1,0,37,29.5,7.51,7.51,0,0,0,29.5,22Zm19-22h-38A10.51,10.51,0,0,0,0,10.5v38A10.51,10.51,0,0,0,10.5,59h38A10.51,10.51,0,0,0,59,48.5v-38A10.51,10.51,0,0,0,48.5,0Zm-19,42A12.5,12.5,0,1,1,42,29.5,12.52,12.52,0,0,1,29.5,42ZM46,18a5,5,0,1,1,5-5A5,5,0,0,1,46,18ZM29.5,22A7.5,7.5,0,1,0,37,29.5,7.51,7.51,0,0,0,29.5,22Z"}))))]);
}

Instagram.defaultProps = {"viewBox":"0 0 59 59"};

module.exports = Instagram;

Instagram.default = Instagram;
